export default __webpack_public_path__ + "3e748c93fe6a87bdedaa920647126557.woff2";